import type { FilterValues } from "@/services/filter";

/** Result type with filter definition IDs as keys and value IDs as array values */
export type MappedFilterValues = Record<string, string[]>;

/**
 * Normalizes filter values from URL format to API format, keeping slugs as-is.
 * Use this when the API supports slugs directly (no slug→ID mapping needed).
 * - Range values (_min/_max) are converted to cents (* 100)
 * - All values are normalized to string arrays
 * - Empty values are filtered out
 */
export function normalizeFilterSlugsForApi(filterValues: FilterValues): MappedFilterValues {
  const result: MappedFilterValues = {};

  for (const [key, value] of Object.entries(filterValues)) {
    if (value === undefined || value === "") continue;
    if (Array.isArray(value) && value.length === 0) continue;

    if (key.match(/(_min|_max)$/)) {
      // Range inputs are always strings; non-string values (e.g. arrays) are intentionally skipped
      if (typeof value === "string") {
        const numeric = Number(value);
        if (!isNaN(numeric)) {
          result[key] = [String(Math.round(numeric * 100))];
        }
      }
      continue;
    }

    result[key] = Array.isArray(value) ? value : [value];
  }

  return result;
}
